import Axios from "axios";
import { ApiResultModel } from "../models/common.model";
import { IChangeNoticeStatusToObservedRequest, IChangeNoticeStatusToObservedResponse, IGetNoticeCountResponse, IGetNoticesResponse } from "../models/notification.model";
import { APIBASE_URL, APPNOTICE } from "../config/cacheKey";

export const getNoticeCount = (): Promise<number> => {
    return Axios.post<ApiResultModel<number>>(
        APIBASE_URL + APPNOTICE + '/GetNoticeCount'
    ).then((result) => {
        return result.data.data;
    });
};


export const getNotices = (): Promise<IGetNoticesResponse[]> => {
    return Axios.post<ApiResultModel<IGetNoticesResponse[]>>(
        APIBASE_URL + APPNOTICE + '/GetNotices'
    ).then((result) => {
        return result.data.data;
    });
};
export const changeNoticeStatusToObserved = (data: IChangeNoticeStatusToObservedRequest)
    : Promise<boolean> => {
    return Axios.post<ApiResultModel<boolean>>(
        APIBASE_URL + APPNOTICE + '/ChangeNoticeStatusToObserved',
        data
    ).then((result) => {
        return result.data.data;
    });
};
